const KPI_FRAGMENT = `
    total
    lastPeriodPercentageChange
`;

const COMPLETE_STATS_FRAGMENT = `
    total
    lastPeriodPercentageChange
    dailyData {
        date
        value
    }
`;

export const GET_KPIS = `query GetKPIS($startDate: Date!, $endDate: Date!) {   
    merchant{
        metadata
        merchantStats(startDate: $startDate endDate: $endDate platforms:[TIKTOK]){
            videosPosted{
                ${KPI_FRAGMENT}
            }
            videoViews{
                ${KPI_FRAGMENT}
            }
            productClicks{
                ${KPI_FRAGMENT}
            }
            attributedGmv{
                ${KPI_FRAGMENT}
            }
            totalGmv {
                ${COMPLETE_STATS_FRAGMENT}
            }
            engagedCreators{
                ${COMPLETE_STATS_FRAGMENT}
            }
            visits{   
                ${COMPLETE_STATS_FRAGMENT}
            }
            orders{    
                ${COMPLETE_STATS_FRAGMENT}
            }
        }
    }
}`;
